import WelcomeContinued  from "./WelcomeContinued"

export default  WelcomeContinued;
